import { getOneXpExperiments } from 'src/universal/redux/oneXp';
import {
  getExperimentalPageData,
  getPageData,
  getPageFirstCardData
} from 'src/universal/redux/page';
import { createSelector } from 'reselect';

export const tncKeys = ['offerTerms', 'ratesFees'];

export const isG163Variant = createSelector(
  [getOneXpExperiments],
  oneXpExperiments => {
    return (
      oneXpExperiments['GCS-163-BPlat-PDP-Seamless-Campaign']?.dimensions[0]
        ?.variant === 'experiment'
    );
  }
);

export const getCombinedG163Data = createSelector(
  [isG163Variant, getExperimentalPageData, getPageFirstCardData, getPageData],
  (g163Variant, { g163SeamlessCampaign }, currCard, pageData) => {
    return {
      isG163Variant: g163Variant,
      staticG163Data: g163SeamlessCampaign,
      currCard,
      pageData
    };
  }
);
